import appEn from './en.json';
import appHe from './he.json';

export default {
    en: {
        app: appEn,
    },
    he: {
        app: appHe
    },
};